import "../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { inject as u } from "../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const o = "@css-render/vue3-ssr";
function i(e, n) {
  return `<style cssr-id="${e}">
${n}
</style>`;
}
function c(e, n, t) {
  const { styles: r, ids: s } = t;
  s.has(e) || r !== null && (s.add(e), r.push(i(e, n)));
}
const d = typeof document != "undefined";
function p() {
  if (d)
    return;
  const e = u(o, null);
  if (e !== null)
    return {
      adapter: (n, t) => c(n, t, e),
      context: e
    };
}
export {
  p as useSsrAdapter
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@css-render_vue3-ssr@0.15.14_vue@3.5.18/~/@css-render/vue3-ssr/esm/index.js
// module id = 136
// module chunks = 41